import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import Formsy from "formsy-react";
import qs from "qs";

import { getPasswordLoginHref } from "../../../../../lib/auth/authLoginPageTypes";
import { getLoginOtpWithAuthQueryUrl } from "../../../../../lib/auth/authRedirectUrl";
import { getLoginOtpNavigationState } from "../../../../../lib/auth/loginOtpNavigationState";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import AuthOrDivider from "../../../auth/AuthPageLayout/components/AuthOrDivider";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import SocialLogin from "../../../auth/SocialLogin";
import InvisibleReCaptcha from "../../../common/InvisibleReCaptcha";
import { TextButton } from "../../../common/Typography";
import LoginRegisterPrompt from "./LoginRegisterPrompt";

function OtpLoginForm({
  formBuilder,
  otpRequest,
  otpRequestLoading,
  locale,
  translate,
  search = "",
  registerTo
}) {
  const history = useHistory();
  const reCaptchaRef = useRef(null);
  const passwordLoginTo = getPasswordLoginHref(locale, search);
  const params = qs.parse(search, { ignoreQueryPrefix: true });
  const redirectTo =
    typeof params.redirectTo === "string" && params.redirectTo.length > 0
      ? params.redirectTo
      : undefined;

  const handleSubmit = async () => {
    const user = formBuilder.fields.find(field => field.name === "user")?.value;
    const recaptcha = await reCaptchaRef.current?.executeAsync?.();

    if (!recaptcha || !user) {
      return;
    }

    otpRequest({
      user,
      recaptcha,
      ...(redirectTo ? { redirectTo } : {}),
      onSuccess: () => {
        history.push(
          getLoginOtpWithAuthQueryUrl({ locale, returnUrl: redirectTo }),
          getLoginOtpNavigationState({ user, fromRegister: false })
        );
      }
    });
  };

  return (
    <AuthPageLayout
      title={translate("auth_login-page_title")}
      subtitle={translate("auth_login-page_subtitle")}
    >
      <SocialLogin />
      <AuthOrDivider />
      <Formsy onValidSubmit={handleSubmit}>
        <FormBuilderWeb {...formBuilder} />
        <div className={"block text-sm text-black text-right w-full"}>
          <TextButton
            onClick={() => {
              history.push(passwordLoginTo);
            }}
          >
            {translate("auth_login-page_password-login-link")}
          </TextButton>
        </div>
        <button
          type={"submit"}
          disabled={otpRequestLoading}
          className={
            "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
          }
        >
          {otpRequestLoading ? (
            <i className="fal fa-spinner fa-spin text-black font-semibold mr-2" />
          ) : null}
          {translate("auth_login-page_submit")}
        </button>
        <LoginRegisterPrompt registerTo={registerTo} translate={translate} />
      </Formsy>
      <InvisibleReCaptcha ref={reCaptchaRef} />
    </AuthPageLayout>
  );
}

export default OtpLoginForm;
